<template>
  <div id="container" v-if="request && userConnected">
    <div id="title">
      <h1>Demande n°{{ request.id }}</h1>
    </div>
    <div id="container-map" class="big-map">
      <maps
        :draw="false"
        :defaultLayers="['TRANSPORTNETWORKS.ROADS']"
        :vectorLayers="vectorLayers"
      ></maps>
    </div>
    <div id="content">
      <div class="block-flat">
        <div class="info-demande">
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="9">
              <b-row>
                <b-col
                  cols="6"
                  sm="3"
                  md="3"
                  lg="3"
                  class="no-padding text-center"
                >
                  <p class="info-title">
                    <font-awesome-icon icon="tag"></font-awesome-icon>
                    Date de dépôt
                  </p>
                  {{ request.depositDate }}
                </b-col>
                <b-col
                  cols="6"
                  sm="3"
                  md="3"
                  lg="3"
                  class="no-padding text-center"
                >
                  <p class="info-title">
                    <font-awesome-icon icon="sign-in-alt"></font-awesome-icon>
                    Début des travaux
                  </p>
                  {{ request.dateStart }}
                </b-col>
                <b-col
                  cols="6"
                  sm="3"
                  md="3"
                  lg="3"
                  class="no-padding text-center"
                >
                  <p class="info-title">
                    <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>
                    Fin des travaux
                  </p>
                  {{ request.dateEnd }}
                </b-col>
                <b-col
                  cols="6"
                  sm="3"
                  md="3"
                  lg="3"
                  class="no-padding text-center"
                >
                  <p :class="'info-title statut-' + request.state.id">
                    <font-awesome-icon icon="square"></font-awesome-icon>
                    Statut de la demande
                  </p>
                  {{ request.state.name }}
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12" sm="12" md="12" lg="12" xl="3">
              <b-row>
                <b-col
                  cols="9"
                  sm="9"
                  md="9"
                  lg="9"
                  class="no-padding text-right boite-outils first-boite"
                >
                  <div
                    class="inline-block"
                    v-if="
                      (userConnected &&
                        userConnected.roles.includes('ROLE_ADMIN')) ||
                      userConnected.roles.includes('ROLE_USER') ||
                      (userConnected.roles.includes('ROLE_SOUSTRAITANT') &&
                        request &&
                        request.state &&
                        request.state.name !==
                          'En attente de transfert au demandeur' &&
                        request.state.name !== 'En attente de réorientation' &&
                        request.state.name !== 'Transférée pour instruction')
                    "
                  >
                    <b-button
                      v-if="request.state.name === 'Transférée en complétude'"
                      @click="editDossier(request.id)"
                      variant="warning"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Modifier ma demande"
                    >
                      <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                    </b-button>
                  </div>

                  <div
                    class="inline-block"
                    v-if="
                      showTicketOfficeAction &&
                      (userConnected.roles.includes('ROLE_ADMIN') ||
                        userConnected.roles.includes('ROLE_GUICHET')) &&
                      (request.state.name === 'En attente de réorientation' ||
                        request.state.name === 'En cours' ||
                        request.state.name === 'En cours d\'instruction' ||
                        request.state.name === 'Complétude réalisée') &&
                      request.managerPerimeter == null
                    "
                  >
                    <b-button
                      v-if="userConnected.roles.includes('ROLE_ADMIN')"
                      @click="editDossier(request.id)"
                      variant="dark"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Mise à jour du dossier"
                    >
                      <font-awesome-icon icon="edit"></font-awesome-icon>
                    </b-button>
                    <b-button
                      @click="showTransfertActions()"
                      variant="dark"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Transférer le dossier"
                    >
                      <font-awesome-icon
                        icon="share-square"
                      ></font-awesome-icon>
                    </b-button>
                  </div>
                  <div
                    class="inline-block"
                    v-if="
                      (userConnected.roles.includes('ROLE_ADMIN') ||
                        userConnected.roles.includes('ROLE_GUICHET') ||
                        userConnected.roles.includes('ROLE_GESTIONNAIRE')) &&
                      request.state.name !== 'Transférée en complétude' &&
                      request.state.name !== 'Traitée'
                    "
                  >
                    <b-modal
                      @ok="runIfOkClickedTransfertDossierDemandeur()"
                      cancel-title="Annuler"
                      id="modal_compl"
                      size="lg"
                      title="Complétude"
                    >
                      <b-alert show variant="primary">
                        Veuillez cocher les documents qui n'ont pas correctement
                        été saisis, ou qui n'ont pas été transmis :
                      </b-alert>
                      <b-form-checkbox-group
                        v-model="missingDocuments"
                        :options="typeDocuments"
                        value-field="id"
                        text-field="name"
                        class="popup-custom-checkbox"
                        stacked
                      >
                      </b-form-checkbox-group>
                      <label style="padding-top: 30px" for="comment">
                        Commentaires :
                      </label>
                      <b-form-textarea
                        v-model="request.comment"
                        id="comment"
                      ></b-form-textarea>
                    </b-modal>
                    <b-button
                      v-b-modal.modal_compl
                      variant="warning"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Demande de complétude"
                    >
                      <font-awesome-icon icon="sync"></font-awesome-icon>
                    </b-button>
                  </div>
                  <div
                    class="inline-block"
                    v-if="
                      userConnected.roles.includes('ROLE_GESTIONNAIRE') ||
                      userConnected.roles.includes('ROLE_ADMIN')
                    "
                  >
                    <b-button
                      @click="rollBackDecision('14024')"
                      v-if="
                        request.cerfa1402401 != null &&
                        request.cerfa1402401.isFavorable != null
                      "
                      variant="danger"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Annuler la decision du cerfa 14024"
                    >
                      <font-awesome-icon icon="car"></font-awesome-icon>
                    </b-button>
                    <b-button
                      @click="rollBackDecision('14023')"
                      v-if="
                        request.cerfa1402301 != null &&
                        request.cerfa1402301.isFavorable != null
                      "
                      variant="danger"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Annuler la decision du cerfa 14023"
                    >
                      <font-awesome-icon icon="road"></font-awesome-icon>
                    </b-button>
                  </div>
                  <div
                    class="inline-block"
                    v-if="
                      showTicketOfficeAction &&
                      (userConnected.roles.includes('ROLE_GESTIONNAIRE') ||
                        userConnected.roles.includes('ROLE_ADMIN')) &&
                      (request.state.name === 'Transférée pour instruction' ||
                        request.state.name == 'Complétude réalisée') &&
                      request.managerPerimeter != null
                    "
                  >
                    <b-button
                      @click="reOrientationDossierGestionnaire()"
                      variant="warning"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Demande de réorientation"
                    >
                      <font-awesome-icon icon="undo"></font-awesome-icon>
                    </b-button>
                    <b-button
                      @click="showModalDecision('14024')"
                      v-if="
                        request.cerfa1402401 != null &&
                        request.cerfa1402401.isFavorable == null
                      "
                      variant="success"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Rendre une décision sur le cerfa 14024"
                    >
                      <font-awesome-icon icon="car"></font-awesome-icon>
                    </b-button>
                    <b-button
                      v-if="
                        request.cerfa1402301 != null &&
                        request.cerfa1402301.isFavorable == null
                      "
                      @click="showModalDecision('14023')"
                      variant="success"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Rendre une décision sur le cerfa 14023"
                    >
                      <font-awesome-icon icon="road"></font-awesome-icon>
                    </b-button>
                    <b-modal
                      @close="closeDecisionModal"
                      hide-footer
                      v-model="decision_modal"
                      size="lg"
                      :title="'Décision sur le cerfa ' + typeDecision"
                    >
                      <ValidationObserver v-slot="{ handleSubmit }">
                        <b-form @submit.prevent="handleSubmit(decision)">
                          <b-row>
                            <b-col lg="3" md="3" sm="12" cols="12">
                              <label class="control-label"
                                >Décision :<span class="red">*</span></label
                              >
                            </b-col>
                            <b-col lg="9" md="9" sm="12" cols="12">
                              <ValidationProvider
                                mode="lazy"
                                v-slot="{ errors }"
                                rules="required"
                                name="décision"
                              >
                                <b-form-radio-group
                                  v-model="decisionTmp.isFavorable"
                                  :options="optionsDecision"
                                  name="radio-options"
                                ></b-form-radio-group>
                                <div class="error">{{ errors[0] }}</div>
                              </ValidationProvider>
                            </b-col>
                          </b-row>
                          <b-row v-if="decisionTmp.isFavorable == true">
                            <b-col lg="3" md="3" sm="12" cols="12">
                              <label class="control-label"
                                >Arrêté de décision :<span class="red"
                                  >*</span
                                ></label
                              >
                            </b-col>
                            <b-col lg="9" md="9" sm="12" cols="12">
                              <ValidationProvider
                                mode="lazy"
                                rules="required"
                                v-slot="{ errors }"
                                name="arrêté"
                              >
                                <b-form-file
                                  browse-text="Déposer"
                                  v-model="arrete.file"
                                  :state="errors[0] ? false : null"
                                  placeholder="Choisissez un Fichier ou glissez le ici..."
                                  drop-placeholder="Glissez un Fichier ici..."
                                ></b-form-file>
                                <div class="error">{{ errors[0] }}</div>
                              </ValidationProvider>
                            </b-col>
                          </b-row>
                          <b-row v-if="decisionTmp.isFavorable == false">
                            <b-col lg="3" md="3" sm="12" cols="12">
                              <label class="control-label">Commentaire :</label>
                            </b-col>
                            <b-col lg="9" md="9" sm="12" cols="12">
                              <b-form-textarea
                                v-model="decisionTmp.commentDecision"
                                id="commentDecision"
                              ></b-form-textarea>
                            </b-col>
                          </b-row>
                          <b-row>
                            <div class="w-100 text-center">
                              <b-button
                                type="submit"
                                class="mr-5"
                                variant="primary"
                                size="sm"
                                >Valider</b-button
                              >
                              <b-button
                                variant="white"
                                size="sm"
                                @click="closeDecisionModal()"
                                >Annuler</b-button
                              >
                            </div>
                          </b-row>
                        </b-form>
                      </ValidationObserver>
                    </b-modal>
                  </div>

                  <div v-if="showListGestionnaire">
                    <b-form-select
                      v-model="manager"
                      :options="managers"
                      value-field="id"
                      text-field="libelle"
                      block
                      class="mr-2 select"
                      style="width: calc(100% - 100px)"
                    ></b-form-select>
                    <b-button
                      @click="orientationDossierGestionnaire()"
                      variant="success"
                      block
                      class="btn-auto mr-2"
                      v-b-tooltip.hover
                      title="Valider"
                    >
                      <font-awesome-icon icon="check"></font-awesome-icon>
                    </b-button>
                    <b-button
                      @click="undoTransfert()"
                      variant="danger"
                      block
                      class="btn-auto"
                      v-b-tooltip.hover
                      title="Annuler"
                    >
                      <font-awesome-icon
                        icon="times"
                        style="margin: 0 2px"
                      ></font-awesome-icon>
                    </b-button>
                  </div>
                  <b-button
                    v-if="
                      request.comment != null || request.commentDecision != null
                    "
                    v-b-modal.modal-comment
                    variant="success"
                    block
                    class="btn-auto"
                    v-b-tooltip.hover
                    title="Commentaires"
                  >
                    <font-awesome-icon icon="comment"></font-awesome-icon>
                  </b-button>

                  <b-modal
                    id="modal-comment"
                    title="Commentaires"
                    size="lg"
                    hide-footer
                    header-bg-variant="primary"
                    header-text-variant="white"
                  >
                    <div v-if="request.comment != null" class="info-demande">
                      <p class="info-title">
                        Commentaire Complétude de pièce :
                      </p>
                      <p>{{ request.comment }}</p>
                    </div>
                    <div
                      v-if="request.commentDecision != null"
                      class="info-demande"
                    >
                      <p class="info-title">Commentaire Décision :</p>
                      <p>{{ request.commentDecision }}</p>
                    </div>
                  </b-modal>
                </b-col>
                <b-col
                  cols="3"
                  sm="3"
                  md="3"
                  lg="3"
                  class="no-padding text-right boite-outils"
                >
                  <b-button
                    @click="goToList()"
                    variant="info"
                    block
                    class="btn-auto"
                    v-b-tooltip.hover
                    title="Retour à la liste"
                  >
                    <font-awesome-icon icon="reply"></font-awesome-icon>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="detail-demande">
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6" xl="3" class="type-demande">
              <span
                v-if="
                  request.cerfa1402301 != null && request.cerfa1402401 == null
                "
                v-b-tooltip.hover
                :title="
                  request.cerfa1402301.isFavorable == false &&
                  request.cerfa1402301.commentDecision != null
                    ? 'Cerfa n°14023*01 (' +
                      request.cerfa1402301.commentDecision +
                      ')'
                    : 'Cerfa n°14023*01'
                "
              >
                <h5>Permission de voirie</h5>
                <font-awesome-icon
                  :class="
                    request.cerfa1402301.isFavorable != null
                      ? request.cerfa1402301.isFavorable === true ||
                        request.cerfa1402301.isFavorable === 'true'
                        ? 'green'
                        : 'red'
                      : ''
                  "
                  icon="road"
                ></font-awesome-icon>
              </span>

              <span
                v-if="
                  request.cerfa1402401 != null && request.cerfa1402301 == null
                "
                v-b-tooltip.hover
                :title="
                  request.cerfa1402401.isFavorable == false &&
                  request.cerfa1402401.commentDecision != null
                    ? 'Cerfa n°14024*01 (' +
                      request.cerfa1402401.commentDecision +
                      ')'
                    : 'Cerfa n°14024*01'
                "
              >
                <h5>Arrêté de circulation</h5>
                <font-awesome-icon
                  :class="
                    request.cerfa1402401.isFavorable != null
                      ? request.cerfa1402401.isFavorable === true ||
                        request.cerfa1402401.isFavorable === 'true'
                        ? 'green'
                        : 'red'
                      : ''
                  "
                  icon="car"
                ></font-awesome-icon>
              </span>

              <span
                v-if="
                  request.cerfa1402401 == null && request.cerfa1402301 == null
                "
              >
                <h5>Pas de Cerfa</h5>
                <font-awesome-icon icon="question-circle"></font-awesome-icon>
              </span>

              <span
                v-if="
                  request.cerfa1402401 != null && request.cerfa1402301 != null
                "
                id="cerfa14023+24"
              >
                <h5>Permission de voirie et Arrêté de circulation</h5>
                <font-awesome-icon
                  :class="
                    request.cerfa1402301.isFavorable != null
                      ? request.cerfa1402301.isFavorable === true ||
                        request.cerfa1402301.isFavorable === 'true'
                        ? 'green'
                        : 'red'
                      : ''
                  "
                  icon="road"
                ></font-awesome-icon>
                <font-awesome-icon
                  :class="
                    request.cerfa1402401.isFavorable != null
                      ? request.cerfa1402401.isFavorable === true ||
                        request.cerfa1402401.isFavorable === 'true'
                        ? 'green'
                        : 'red'
                      : ''
                  "
                  icon="car"
                ></font-awesome-icon>
                <b-tooltip target="cerfa14023+24" triggers="hover"
                  >Cerfa n°14023*01
                  <span
                    v-if="
                      request.cerfa1402301.isFavorable == false &&
                      request.cerfa1402301.commentDecision != null
                    "
                    >({{ request.cerfa1402301.commentDecision }})</span
                  >
                  et Cerfa n°14024*01
                  <span
                    v-if="
                      request.cerfa1402401.isFavorable == false &&
                      request.cerfa1402401.commentDecision != null
                    "
                    >({{ request.cerfa1402401.commentDecision }})</span
                  >
                </b-tooltip>
              </span>
            </b-col>
            <b-col
              cols="12"
              sm="12"
              md="6"
              lg="6"
              xl="3"
              class="adresse-demande"
            >
              <p class="info-title">
                <font-awesome-icon icon="map-marker-alt"></font-awesome-icon>
                Localisation
              </p>
              <!--<font-awesome-icon icon="map-marker-alt"></font-awesome-icon>-->
              {{ dossierSelected.addressNum }} {{ dossierSelected.addressExt }}
              {{ dossierSelected.addressType }} {{ dossierSelected.addressName
              }}<br />
              {{ dossierSelected.addressPostalCode }}
              {{ dossierSelected.addressCity }}
            </b-col>

            <b-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              xl="6"
              :class="request.cerfa1402301 != null ? 'two-cols' : 'three-cols'"
            >
              <div class="no-padding details-action-double">
                <b-button
                  v-if="request.cerfa1402401 != null"
                  @click="printCerfa('14024', request.id)"
                  variant="white"
                  :disabled="
                    request.cerfa1402401 == null && request.cerfa1402301 == null
                  "
                >
                  <font-awesome-icon icon="print"></font-awesome-icon>
                  Impression 14024*01
                </b-button>
                <b-button
                  v-if="request.cerfa1402301 != null"
                  @click="printCerfa('14023', request.id)"
                  variant="white"
                  :disabled="
                    request.cerfa1402401 == null && request.cerfa1402301 == null
                  "
                >
                  <font-awesome-icon icon="print"></font-awesome-icon>
                  Impression 14023*01
                </b-button>
              </div>
              <div
                class="no-padding details-action-double"
                v-if="request.cerfa1402301 != null"
              >
                <b-modal
                  v-if="request.cerfa1402301 != null"
                  id="modal-detail-travaux"
                  title="Détail des travaux"
                  hide-footer
                  size="xl"
                  header-bg-variant="primary"
                  header-text-variant="white"
                >
                  <customeForm :readOnly="true"></customeForm>
                </b-modal>
                <b-button
                  v-if="request.cerfa1402301 != null"
                  variant="white"
                  v-b-modal.modal-detail-travaux
                  :disabled="request.cerfa1402301 == null"
                >
                  <font-awesome-icon icon="hard-hat"></font-awesome-icon>
                  Travaux
                </b-button>
              </div>
              <div v-if="request" class="no-padding details-action-double">
                <b-modal
                  id="modal-detail-historique"
                  title="Historique de la demande"
                  hide-footer
                  size="xl"
                  header-bg-variant="primary"
                  header-text-variant="white"
                >
                  <history-timeline
                    :id="request.id"
                    :entity="'Request'"
                  ></history-timeline>
                </b-modal>
                <b-button variant="white" v-b-modal.modal-detail-historique>
                  <font-awesome-icon icon="user-secret"></font-awesome-icon>
                  Historique
                </b-button>
              </div>
              <div
                v-if="
                  request &&
                  ((request.cerfa1402301 != null &&
                    request.cerfa1402301.isFavorable != null) ||
                    (request.cerfa1402401 != null &&
                      request.cerfa1402401.isFavorable != null))
                "
                class="no-padding details-action-double action-arrete"
              >
                <div v-for="doc in arretes" :key="doc.id">
                  <div v-if="doc.typeDocument.id == 21">
                    <b-button variant="success" @click="open(doc)">
                      <font-awesome-icon icon="gavel"></font-awesome-icon>
                      Visualiser l'Arrêté du cerfa 14023
                    </b-button>
                  </div>
                  <div v-if="doc.typeDocument.id == 20">
                    <b-button variant="success" @click="open(doc)">
                      <font-awesome-icon icon="gavel"></font-awesome-icon>
                      Visualiser l'Arrêté du cerfa 14024
                    </b-button>
                  </div>
                </div>
                <b-modal
                  title="Visualisation du PDF"
                  hide-footer
                  size="xl"
                  header-bg-variant="primary"
                  header-text-variant="white"
                  v-model="viewerPdf"
                >
                  <vue-pdf-preview
                    style="width: 100%"
                    ref="myPdfComponent"
                    :src="pdfToView"
                    v-for="i in numPages"
                    :key="i"
                    :page="i"
                  ></vue-pdf-preview>
                </b-modal>
              </div>
              <div
                v-if="
                  userConnected &&
                  request &&
                  request.state &&
                  ((request.cerfa1402301 != null &&
                    request.cerfa1402301.isFavorable != null) ||
                    (request.cerfa1402401 != null &&
                      request.cerfa1402401.isFavorable != null))
                "
                class="no-padding details-action-double action-arrete"
              >
                <div v-for="doc in arretes" :key="doc.id">
                  <div v-if="doc.typeDocument.id == 21">
                    <b-button
                      variant="success"
                      @click="download(doc.url, doc.name)"
                    >
                      <font-awesome-icon icon="download"></font-awesome-icon>
                      Télécharger l'arrêté du cerfa 14023
                    </b-button>
                  </div>
                  <div v-if="doc.typeDocument.id == 20">
                    <b-button
                      variant="success"
                      @click="download(doc.url, doc.name)"
                    >
                      <font-awesome-icon icon="download"></font-awesome-icon>
                      Télécharger l'arrêté du cerfa 14024
                    </b-button>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="info-demande">
            <b-col
              v-if="
                request.operationCode != '' && request.operationCode != null
              "
              cols="6"
              sm="3"
              md="3"
              lg="3"
              class="text-center"
            >
              <p class="info-title">
                <font-awesome-icon icon="barcode"></font-awesome-icon>
                Code d'opération
              </p>
              {{ request.operationCode }}
            </b-col>
            <b-col
              v-if="
                request.operationCode != '' && request.operationCode != null
              "
              cols="6"
              sm="3"
              md="3"
              lg="3"
              class="text-center"
            >
              <p class="info-title">
                <font-awesome-icon icon="mobile-alt"></font-awesome-icon>
                Opérateur
              </p>
              <span v-if="request.operatorPerimeter != null">
                {{ request.operatorPerimeter.libelle }}
              </span>
            </b-col>
            <b-col
              v-if="
                request.ticketOffices != null &&
                request.ticketOffices.length > 0
              "
              cols="6"
              sm="3"
              md="3"
              lg="3"
              class="text-center"
            >
              <p class="info-title">
                <font-awesome-icon icon="ticket-alt"></font-awesome-icon>
                Guichet
              </p>
              <span v-if="request.ticketOffices.length > 0">
                <div
                  v-for="ticketOffice in request.ticketOffices"
                  :key="ticketOffice.perimeter.id"
                >
                  <div v-if="ticketOffice.perimeter.type != 'department'">
                    {{ ticketOffice.perimeter.libelle }}
                  </div>
                </div>
              </span>
            </b-col>
            <b-col
              v-if="request.caseNumbers != '' && request.caseNumbers != null"
              cols="6"
              sm="3"
              md="3"
              lg="3"
              class="text-center"
            >
              <p class="info-title">
                <font-awesome-icon icon="suitcase"></font-awesome-icon>
                Numéro d'affaire
              </p>
              {{ request.caseNumbers }}
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" md="12" sm="12" cols="12">
              <documents
                :showValid="false"
                xs="4"
                sm="4"
                xl="4"
                lg="4"
                md="4"
                :card="false"
                :replace="false"
                :remove="false"
                :add="false"
                :documents="request.documents"
                :demande="this.request"
              ></documents>
            </b-col>
          </b-row>
        </div>
        <b-modal
          title="Visualisation du PDF"
          hide-footer
          size="xl"
          header-bg-variant="primary"
          header-text-variant="white"
          v-model="viewerPdf"
        >
          <vue-pdf-preview
            style="width: 100%"
            ref="myPdfComponent"
            :src="pdfToView"
            v-for="i in numPages"
            :key="i"
            :page="i"
          ></vue-pdf-preview>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router/index.js";
import maps from "../components/Maps.vue";
import documents from "../components/Documents.vue";
import customeForm from "./Cerfas/D14023/CustomeForm.vue";
import cerfa_popup from "./Cerfa.vue";
import Vue from "vue";
import Vuex from "vuex";
import {
  createProj,
  addProj,
  findPointOnSurface,
  createStyle,
  createMultiPointGeom,
  loadingBBox,
} from "vuelayers/lib/ol-ext";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Icon from "ol/style/Icon";
import Text from "ol/style/Text";
import Circle from "ol/style/Circle";
import Point from "ol/geom/Point";
import VuePdfPreview from "vue-pdf";
import historyTimeline from "../components/historyTimeline.vue";
export default {
  async mounted() {
    let rep = null;
    rep = await this.getDossier(this.$route.params.id);
    
    // GESTION DE L'ACCES A LA DEMANDE
    let granted = false;

    let requestTicketOfficePerimeters = this.request.ticketOffices.map(r => r.perimeter.id);

    if (this.userConnected.roles.includes("ROLE_ADMIN")) {
      console.log("Granted for ROLE_ADMIN");
      granted = true;
    }


    // Le Guichet voit les demandes de son périmètre
    if (
      this.userConnected.roles.includes("ROLE_GUICHET")
      &&
      (
        this.userConnected.ticketOfficePerimeter !== null &&
        this.userConnected.ticketOfficePerimeter.id !== null
        &&
        requestTicketOfficePerimeters.includes(this.userConnected.ticketOfficePerimeter.id)
      )
      ) {
      console.log("Granted for ROLE_GUICHET");
      granted = true;
    }
    
    // Le Gestionnaire voit les demandes de son périmètre
    if (
      this.userConnected.roles.includes("ROLE_GESTIONNAIRE")
      &&
      (
        this.request.managerPerimeter != null &&
        this.request.managerPerimeter.id !== null
        &&
        this.userConnected.managerPerimeter != null &&
        this.userConnected.managerPerimeter.id !== null
        &&
        this.request.managerPerimeter.id === this.userConnected.managerPerimeter.id
      )
      ) {
      console.log("Granted for ROLE_GESTIONNAIRE");
      granted = true;
    }

    // L'opérateur voit les demandes de son périmètre
    if (
      this.userConnected.roles.includes("ROLE_USER")
      &&
      (
        this.request.operatorPerimeter != null &&
        this.request.operatorPerimeter.id !== null
        &&
        this.userConnected.operatorPerimeter != null &&
        this.userConnected.operatorPerimeter.id !== null
        &&
        this.request.operatorPerimeter.id === this.userConnected.operatorPerimeter.id
      )
      ) {
      console.log("Granted for ROLE_USER");
      granted = true;
    }

    // Le Sous-traitant voit les demandes de son périmètre
    if (
      this.userConnected.roles.includes("ROLE_SOUSTRAITANT")
      &&
      (
        this.request.sousTraitantPerimeter !== null
        &&
        this.userConnected.sousTraitantPerimeter !== null
        &&
        this.request.sousTraitantPerimeter.id === this.userConnected.sousTraitantPerimeter.id
      )
      ) {
      console.log("Granted for ROLE_SOUSTRAITANT");
      granted = true;
    }

    // Si l'utilisateur n'a pas les droits pour visionner la demande, on redirige vers une page 403
    if (!granted) {
      router.push('/403');
    }
    
    if (
      this.userConnected.roles.includes("ROLE_GUICHET") &&
      this.request.stateId != 10 &&
      this.request.stateId == 1
    ) {
      this.request.stateId = 10;
      rep = await this.updateDossier(this.request);
    }

    let type = [];
    if (!!this.request.cerfa1402301) {
      type.push("cerfa14023");
      rep = await this.setCerfa14023(this.request.cerfa1402301);
    }
    if (!!this.request.cerfa1402401) {
      type.push("cerfa14024");
      rep = await this.setCerfa14024(this.request.cerfa1402401);
    }

    rep = await this.getDocumentsFromCerfa(type);
    this.$nextTick(function () {
      if (this.$route.params.id) {
        this.getManagers(this.$route.params.id);
      }
      setTimeout(function () {
        window.Event.$emit("zoomLayer", "DossierLineLayer,DossierPointLayer");
      }, 1000);
    });
  },
  name: "Detail",
  data: () => ({
    decision_modal: false,
    typeDecision: null,
    optionsDecision: [
      { text: "Favorable", value: true },
      { text: "Défavorable", value: false },
    ],
    showListGestionnaire: false,
    showTicketOfficeAction: true,
    missingDocuments: [],
    manager: null,
    decisionTmp: {
      isFavorable: null,
      commentDecision: null,
    },
    arrete: {
      file: null,
      typeDocument: {},
    },
    pdfToView: "",
    viewerPdf: false,
    viewerDoc: false,
    numPages: 1,
    docToView: "",
    imageMimeType: ["image/png", "image/png", "image/gif", "image/jpeg"],
    pdfMimeType: ["application/pdf"],
    DocMimeType: [
      "application/octet-stream",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.oasis.opendocument.text",
      "application/vnd.ms-powerpoint",
      "text/csv",
      "application/vnd.ms-office",
      "text/plain",
      "application/vnd.oasis.opendocument.spreadsheet",
      "application/vnd.oasis.opendocument.presentation",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ],
  }),
  components: {
    customeForm: customeForm,
    maps: maps,
    cerfa_popup: cerfa_popup,
    documents: documents,
    "vue-pdf-preview": VuePdfPreview,
    "history-timeline": historyTimeline,
  },
  methods: {
    async rollBackDecision(type) {
      Vue.prototype.$awn.confirm(
        "Voulez vous vraiment supprimer la décision du cerfa " + type + " ?",
        async () => {
          let rep = null;
          if (type == "14024") {
            this.request.cerfa1402401.isFavorable = null;
            this.request.cerfa1402401.commentDecision = null;
            rep = await this.updateCerfa14024(this.request.cerfa1402401);
            this.request.documents.forEach((element) => {
              if (element.typeDocument.id == 20) {
                this.deleteDocument(element.id);
              }
            });
          }
          if (type == "14023") {
            this.request.cerfa1402301.isFavorable = null;
            this.request.cerfa1402301.commentDecision = null;
            rep = await this.updateCerfa14023(this.request.cerfa1402301);
            this.request.documents.forEach((element) => {
              if (element.typeDocument.id == 21) {
                this.deleteDocument(element.id);
              }
            });
          }
          this.request.stateId = 3;
          rep = await this.updateDossier(this.request);
        },
        () => {}
      );
    },
    closeDecisionModal() {
      this.decision_modal = false;
      this.typeDecision = "";
      this.decisionTmp = {
        isFavorable: null,
        commentDecision: null,
      };
      this.arrete = {
        file: null,
        typeDocument: {},
      };
    },
    showModalDecision(type) {
      this.decision_modal = true;
      this.typeDecision = type;
    },
    download(doc, name) {
      axios({
        method: "get",
        url: doc,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, name);
        })
        .catch(() => console.log("error occured"));
    },

    forceFileDownload(response, name) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    openLocalisation() {
      for (const [key, document] of Object.entries(this.request.documents))
        if (document.typeDocument.id == 3 || document.typeDocument.id == 4)
          window.open(document.url);
    },
    openSituation() {
      for (const [key, document] of Object.entries(this.request.documents))
        if (
          document.typeDocument.id == 1 ||
          document.typeDocument.id == 2 ||
          document.typeDocument.id == 12
        )
          window.open(document.url);
    },
    open(doc) {
      // console.log(doc, this.imageMimeType, this.pdfMimeType, this.DocMimeType);
      if (this.imageMimeType.includes(doc.mimeType)) {
        if (doc.typeDocument.id == 17) {
          window.open(doc.url);
        } else {
          const viewer = this.$el.querySelector(".images" + doc.id).$viewer;
          viewer.show();
        }
      } else if (this.pdfMimeType.includes(doc.mimeType)) {
        this.pdfToView = VuePdfPreview.createLoadingTask(doc.url);
        this.pdfToView.promise.then((pdf) => {
          this.numPages = pdf.numPages;
        });
        this.viewerPdf = true;
      } else if (this.DocMimeType.includes(doc.mimeType)) {
        this.viewerDoc = true;
        this.docToView = doc.url;
        window.open(this.docToView);
      }
    },
    async decision() {
      let rep = null;
      let typedoc = null;
      if (this.typeDecision == "14024") {
        this.request.cerfa1402401.isFavorable = this.decisionTmp.isFavorable
          ? "true"
          : "false";
        this.request.cerfa1402401.commentDecision =
          this.decisionTmp.commentDecision;
        typedoc = 20;

        rep = await this.updateCerfa14024(this.request.cerfa1402401);
      }
      if (this.typeDecision == "14023") {
        this.request.cerfa1402301.isFavorable = this.decisionTmp.isFavorable
          ? "true"
          : "false";
        this.request.cerfa1402301.commentDecision =
          this.decisionTmp.commentDecision;
        typedoc = 21;
        rep = await this.updateCerfa14023(this.request.cerfa1402301);
      }
      if (this.decisionTmp.isFavorable == true) {
        this.arrete.file.requestId = this.request.id;
        this.arrete.file.typeDocumentId = typedoc;
        this.arrete.file.stdUserId = this.userConnected.id;
        rep = await this.sendDocument(this.arrete.file);
      }
      if (
        (this.request.cerfa1402401 != null &&
          this.request.cerfa1402401.isFavorable != null &&
          this.request.cerfa1402301 == null) ||
        (this.request.cerfa1402301 != null &&
          this.request.cerfa1402301.isFavorable != null &&
          this.request.cerfa1402401 == null) ||
        (this.request.cerfa1402301 != null &&
          this.request.cerfa1402301.isFavorable != null &&
          this.request.cerfa1402401 != null &&
          this.request.cerfa1402401.isFavorable != null)
      ) {
        this.request.stateId = 11;
        rep = await this.updateDossier(this.request);
      }
      this.closeDecisionModal();
    },
    showTransfertActions() {
      this.showTicketOfficeAction = false;
      this.showListGestionnaire = true;
    },
    async runIfOkClickedTransfertDossierDemandeur() {
      this.request.stateId = 8;
      this.request.missingDocuments = this.missingDocuments;
      let rep = await this.updateDossier(this.request);
    },
    async reOrientationDossierGestionnaire() {
      this.request.stateId = 6;
      this.request.managerPerimeterId = null;
      let rep = await this.updateDossier(this.request);
    },
    async orientationDossierGestionnaire() {
      this.request.stateId = 3;
      this.request.managerPerimeterId = this.manager;
      if (
        this.manager != null &&
        this.manager != "" &&
        this.manager !== "undefined"
      ) {
        let rep = await this.updateDossier(this.request);
        this.showTicketOfficeAction = true;
        this.showListGestionnaire = false;
      } else {
        Vue.prototype.$awn.alert(
          "Veuillez choisir un gestionnaire qui instruira le dossier"
        );
      }
    },
    editDossier(id) {
      router.push({ name: "updatedossier", params: { id: id } });
    },
    undoTransfert() {
      this.showListGestionnaire = false;
      this.showTicketOfficeAction = true;
    },

    goToList() {
      router.push({ name: "Dossiers" });
    },
    goToCerfa(type, id) {
      // let encrypted = this.$aes.encrypt(id.toString());
      router.push({ name: "Cerfa", params: { type: type, id: id } });
    },
    printCerfa(type, id) {
      Vue.axios
        .get(window.urlapi + "request/" + id + "/pdf/" + type)
        .then((response) => {
          window.open(response.data.message);
        });
    },
    ...Vuex.mapActions("Dossiers", [
      "getDossier",
      "updateDossier",
      "getManagers",
      "setDossier",
    ]),
    ...Vuex.mapActions("Document", [
      "getDocumentsFromCerfa",
      "sendDocument",
      "deleteDocument",
    ]),
    ...Vuex.mapActions("Cerfa", [
      "setCerfa14023",
      "setCerfa14024",
      "updateCerfa14023",
      "updateCerfa14024",
    ]),
  },
  computed: {
    arretes() {
      let data = [];

      this.request.documents.forEach(function (element) {
        if (element.typeDocument.id == 21 || element.typeDocument.id == 20) {
          data.push(element);
        }
      });

      return data;
    },
    request: {
      get() {
        return this.dossierSelected;
      },
      set(value) {
        this.setDossier(value);
      },
    },
    vectorLayers: function () {
      let tab = [];
      if (typeof this.request !== "undefined") {
        // console.log(this.dossierSelected);
        tab.push({
          vectorZIndex: 100,
          ref: "DossierPointLayer",
          visible: true,
          features: this.request.point,
          factory: function () {
            return (feature) => {
              if (feature.getProperties().marker) {
                return [
                  new Style({
                    zIndex: 150,
                    image: new Icon({
                      src: require("../img/marker-map/" +
                        feature.getProperties().marker),
                      scale: 0.5,
                    }),
                  }),
                ];
              } else {
                return [];
              }
            };
          },
          click: function (feature) {},
        });

        tab.push({
          vectorZIndex: 99,
          ref: "DossierLineLayer",
          visible: true,
          features: this.features,
          factory: function () {
            return (feature) => {
              return [
                new Style({
                  zIndex: 100,
                  image: new Circle({
                    radius: 5,
                    stroke: new Stroke({
                      width: 6,
                      color: "#fbc02d",
                    }),
                    fill: new Fill({
                      color: "#fbc02d",
                    }),
                  }),
                  stroke: new Stroke({
                    width: 6,
                    color: "#fbc02d",
                  }),
                  fill: new Fill({
                    color: "rgba(255,255,255,0.5)",
                  }),
                }),
              ];
            };
          },
          click: function (feature) {},
        });
      }

      return tab;
    },
    ...Vuex.mapGetters("Dossiers", ["dossierSelected", "features", "managers"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
    ...Vuex.mapGetters("Document", ["typeDocuments"]),
  },
};
</script>
